module.exports = __webpack_public_path__ + "img/empty.940148f6.png";